import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useThemeMode } from '../context/ThemeContext';
import './Header.css';
import vicLogo from '../assets/vic_logo.png';

const Header = ({ isAuthenticated, onLogout }) => {
  const navigate = useNavigate();
  const { mode, toggleTheme } = useThemeMode();

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          <span className="logo-icon"><img src={vicLogo} alt="VIC - Service Checker Logo" /></span>
          <span className="logo-text">Service Checker</span>
        </Link>

        <nav className="header-nav">
          <Link to="/" className="nav-link">Home</Link>
          <a href="#features" className="nav-link">Features</a>
          <a href="#how-it-works" className="nav-link">How It Works</a>
          <a href="#pricing" className="nav-link">Pricing</a>
          {isAuthenticated && (
            <Link to="/apis" className="nav-link">APIs</Link>
          )}
        </nav>

        <div className="header-actions">
          <Tooltip title={mode === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}>
            <IconButton onClick={toggleTheme} color="inherit" size="small">
              {mode === 'light' ? <Brightness4 /> : <Brightness7 />}
            </IconButton>
          </Tooltip>
          {isAuthenticated ? (
            <>
              <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
                Dashboard
              </button>
              <button className="btn btn-outline" onClick={onLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-outline" onClick={() => navigate('/login')}>
                Login
              </button>
              <button className="btn btn-primary" onClick={() => navigate('/register')}>
                Register
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
